import { useMutation } from "@tanstack/react-query";
import { presignDocument } from "../api";
import { downloadFile, showToast } from "@/modules/common/utils";
import { TOAST_IDS, ToastType } from "@/modules/common/types";

const useDownloadDocument = () => {
  const mutation = useMutation({
    mutationFn: (documentId: string) => presignDocument(documentId),
    onSuccess: (data) => {
      downloadFile(data.data.url);
    },
    onError: () => {
      showToast({
        type: ToastType.ERROR,
        message: "Failed to download document",
        toastId: TOAST_IDS.DOWNLOAD_DOCUMENT_ERROR,
        options: {
          position: "bottom-left",
          autoClose: 3000,
        },
      });
    },
  });

  return {
    download: mutation.mutate,
    isDownloading: mutation.isPending,
  };
};

export default useDownloadDocument;
